module.exports = __webpack_public_path__ + "img/menuIcon2.87c59174.png";